import React from "react";
import PropTypes from "prop-types";

import classnames from "classnames";
import isEmptyObject from "shared/util/isEmptyObject";

import {
	CREDIT_FORM_NAMES,
	CREDIT_FORM_AUTOCOMPLETE,
} from "shared/payment/constants";

import Input from "apps/payment/components/Input";
import CardInput from "apps/payment/components/CardInput";
import ErrorBlock from "apps/payment/components/ErrorBlock";
import PurchaseButton from "apps/payment/components/PurchaseButton";
import CardCvvHelp from "apps/payment/components/CardCvvHelp";

import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./CreditPurchase.scss";

const {
	cardholderName,
	cardNumber,
	cvv,
	expiration,
	zipCode,
	creditPurchaseScreen,
} = CREDIT_FORM_NAMES;

const zipLabel = window.Context.get("country") === "US" ?	_str("Zip code") : _str("Postal code");

export const CreditPurchase = ({
	form,
	cardType,
	errorMessage,
	setForm,
	handleFormBlur,
	confirmPurchaseNewCard,
	isSuccessful,
	isPurchasing,
	isEditingInfo,
	userInfo,
	paymentToken,
}) => (
	<form
		onSubmit={(e) => {
			e.preventDefault();

			if (!isSuccessful && !isPurchasing) {
				confirmPurchaseNewCard();
			}
		}}
		onBlur={({ target: { name } }) => handleFormBlur({ name })}
		onChange={({ target: { name, value } }) => setForm({ name, value })}
		className={classnames({
			"payment-credit-purchase": true,
		})}
	>
		<h2 className="payment-credit-purchase-header">
			<Str>Enter your billing information</Str>
		</h2>

		<ErrorBlock
			message={errorMessage[creditPurchaseScreen]}
		/>

		<Input
			className={classnames({
				"payment-credit-purchase-cardholder-name": true,
				"payment-credit-purchase-cardholder-name--errors": errorMessage[cardholderName],
			})}
			name={cardholderName}
			autoComplete={CREDIT_FORM_AUTOCOMPLETE[cardholderName]}
			label={_str("Cardholder Name")}
			value={form[cardholderName]}
		>
			<ErrorBlock
				message={errorMessage[cardholderName]}
			/>
		</Input>
		<CardInput
			className={classnames({
				"payment-credit-purchase-card-number": true,
				"payment-credit-purchase-cardholder-name--errors": errorMessage[cardNumber],
			})}
			name={cardNumber}
			autoComplete={CREDIT_FORM_AUTOCOMPLETE[cardNumber]}
			label={_str("Card Number")}
			value={form[cardNumber]}
			cardType={cardType}
		>
			<ErrorBlock
				message={errorMessage[cardNumber]}
			/>

			{!errorMessage[cardNumber] &&
				<div className="payment-credit-purchase-acceptance">
					<Str>We accept all major debit/credit cards.</Str>
				</div>
			}
		</CardInput>
		<div className="payment-credit-purchase-col-container">
			<div className="payment-credit-purchase-col">
				<Input
					className={classnames({
						"payment-credit-purchase-cvv": true,
						"payment-credit-purchase-cardholder-name--errors": errorMessage[cvv],
					})}
					name={cvv}
					autoComplete={CREDIT_FORM_AUTOCOMPLETE[cvv]}
					label={_str("CVV")}
					value={form[cvv]}
				>
					<ErrorBlock
						message={errorMessage[cvv]}
					/>

					<CardCvvHelp />
				</Input>
			</div>
			<div className="payment-credit-purchase-col">
				<Input
					className={classnames({
						"payment-credit-purchase-expiration": true,
						"payment-credit-purchase-cardholder-name--errors": errorMessage[expiration],
					})}
					name={expiration}
					autoComplete={CREDIT_FORM_AUTOCOMPLETE[expiration]}
					label={_str("Expiration")}
					value={form[expiration]}
				>
					<ErrorBlock
						message={errorMessage[expiration]}
					/>
				</Input>
			</div>
			<div className="payment-credit-purchase-col">
				<Input
					className={classnames({
						"payment-credit-purchase-zip-code": true,
						"payment-credit-purchase-cardholder-name--errors": errorMessage[zipCode],
					})}
					name={zipCode}
					autoComplete={CREDIT_FORM_AUTOCOMPLETE[zipCode]}
					label={zipLabel}
					value={form[zipCode]}
				>
					<ErrorBlock
						message={errorMessage[zipCode]}
					/>
				</Input>
			</div>
		</div>

		<PurchaseButton
			isSuccessful={isSuccessful}
			isPurchasing={isPurchasing}
			isEditingInfo={isEditingInfo}
			hasPaymentToken={!isEmptyObject(paymentToken)}
			state={userInfo.state}
		>
			<div className="payment-credit-purchase-security">
				<i
					className={classnames("okicon i-lock-closed", {
						"payment-credit-purchase-security-icon": true,
					})}
				/>
				<Str>Secure</Str>
			</div>
		</PurchaseButton>
	</form>
);

CreditPurchase.propTypes = {
	form: PropTypes.object.isRequired,
	cardType: PropTypes.string,
	paymentToken: PropTypes.object,
	errorMessage: PropTypes.object.isRequired,
	setForm: PropTypes.func.isRequired,
	handleFormBlur: PropTypes.func.isRequired,
	confirmPurchaseNewCard: PropTypes.func.isRequired,
	isSuccessful: PropTypes.bool.isRequired,
	isPurchasing: PropTypes.bool.isRequired,
	isEditingInfo: PropTypes.bool.isRequired,
	userInfo: PropTypes.shape({
		state: PropTypes.string,
	}).isRequired,
};

export default CreditPurchase;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CreditPurchase/index.jsx